export default "__VITE_ASSET___Gwb1amo__"